import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginApi, setAuth } from '../auth';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../styles/login.css';

export default function Login() {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setIsLoading(true);

    try {
      const res = await loginApi(user, pass);
      
      setAuth(res.token, res.username);
      nav('/');
    } catch(ex) {
      console.log('Login failed:', ex);
      setErr('Invalid username or password');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div className="auth-header">
          <h2>Welcome Back</h2>
          <p>Login to manage your account</p>
        </div>

        <form onSubmit={submit} className="auth-form">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              placeholder="Enter your username"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              required
            />
          </div>

          {/* 🔐 PASSWORD WITH EYE ICON */}
          <div className="form-group">
            <label>Password</label>
            <div className="password-input-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                required
                className="password-input"
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {err && <div className="error-message">{err}</div>}

          <button type="submit" className="login-btn" disabled={isLoading}>
            {isLoading ? <span className="spinner"></span> : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}